/**
 * Fluid container patterns. Each container has at least 6% horizontal
 * padding (3% each side via the 94% min()) and is capped at a
 * content-type-specific maximum. Replaces the breakpoint-stepped
 * approach so resizing the browser produces continuous reflow with
 * no snap points.
 *
 * Three caps:
 *   - CONTENT_MAX_W (1200px) — default for dashboards, lists, mixed content
 *   - READ_MAX_W    (720px)  — read-focused, single-column reading
 *   - FORM_MAX_W    (480px)  — forms, narrow for readability + scan-ability
 *
 * Use the matching *_CONTAINER variants when you also want
 * centering + full-width.
 */
export const CONTENT_MAX_W = 'max-w-[min(94%,1024px)]'
export const READ_MAX_W = 'max-w-[min(94%,720px)]'
export const FORM_MAX_W = 'max-w-[min(94%,480px)]'

/**
 * Centered + full-width containers. Apply to a top-level page wrapper
 * or section. CONTENT_CONTAINER is the default; switch to
 * READ_CONTAINER or FORM_CONTAINER for narrower content.
 */
export const CONTENT_CONTAINER = `${CONTENT_MAX_W} mx-auto w-full`
export const READ_CONTAINER = `${READ_MAX_W} mx-auto w-full`
export const FORM_CONTAINER = `${FORM_MAX_W} mx-auto w-full`
